"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internal
 * Trigger a plugin event
 * @param core The EditorCore object
 * @param pluginEvent The event object to trigger
 * @param broadcast Set to true to skip the shouldHandleEventExclusively check
 */
exports.triggerEvent = function (core, pluginEvent, broadcast) {
    if (!core.lifecycle.shadowEditFragment &&
        (broadcast || !core.plugins.some(function (plugin) { return handledExclusively(pluginEvent, plugin); }))) {
        core.plugins.forEach(function (plugin) {
            if (plugin.onPluginEvent) {
                plugin.onPluginEvent(pluginEvent);
            }
        });
    }
};
function handledExclusively(event, plugin) {
    var _a;
    if (plugin.onPluginEvent && ((_a = plugin.willHandleEventExclusively) === null || _a === void 0 ? void 0 : _a.call(plugin, event))) {
        plugin.onPluginEvent(event);
        return true;
    }
    return false;
}
//# sourceMappingURL=triggerEvent.js.map